// @core/api/endpoints/localization/list_translations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTranslationsResponse,
} from '../../../types/localization';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/localization';

/**
 * List translations
 * Returns translations for a key across locales, or all translations for a locale in a namespace.
 */
export async function ListTranslations(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTranslationsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/translations`;
  const requestOptions = options;
  return client.get<ListTranslationsResponse>(requestPath, { ...requestOptions, params });
}
